import { FC, useEffect, useState } from "react";
import {
  Stack,
  Box,
  useColorModeValue,
  Button,
  Center,
  Link,
} from "@chakra-ui/react";
import { Form, Formik } from "formik";
import Layout from "components/Layout";
import TextInput from "components/TextInput";
import { ILoginPayload } from "interfaces/auth";
import { authValidationSchema } from "utils/validationSchema";
import Logo from "components/Logo";
import useAuth from "hooks/useAuth";
import { useAuthContext } from "components/AuthProvider";
import { useNavigate } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";

const Login: FC = () => {
  const { login } = useAuth();
  const [isLoading, setLoading] = useState(false);
  const { user } = useAuthContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (user !== null) {
      // logout();
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <Layout withSidebar={false}>
      <Center minH="100vh">
        <Box
          rounded={"lg"}
          bg={useColorModeValue("white", "gray.700")}
          boxShadow={"lg"}
          p={8}
          w="sm"
        >
          <Center>
            <Logo mb="6" w="60%" />
          </Center>
          <Formik<ILoginPayload>
            initialValues={{ email: "", password: "" }}
            validationSchema={authValidationSchema}
            onSubmit={async ({ email, password }, helpers) => {
              try {
                setLoading(true);
                await login({ email, password });
              } catch (error) {
                if (error instanceof Error) {
                  helpers.setErrors({ email: error.message });
                }
              } finally {
                setLoading(false);
              }
            }}
          >
            <Form>
              <Stack spacing={4}>
                <TextInput name="email" id="email" label="Email" />
                <TextInput
                  name="password"
                  type="password"
                  id="password"
                  label="Password"
                />
                <Button colorScheme="green" type="submit" isLoading={isLoading}>
                  Login
                </Button>

                <Center>
                  <Link
                    as={RouterLink}
                    to="/forgot-password"
                    color={"blue.400"}
                  >
                    Forgot password?
                  </Link>
                </Center>
              </Stack>
            </Form>
          </Formik>
        </Box>
      </Center>
    </Layout>
  );
};

export default Login;
